import Metamask from './metamask.svg';
import Phantom from './phantom.svg';
import Solflare from './solflare.svg';
import Tread from './tread.svg';

const ICONS = {
  metamask: Metamask,
  phantom: Phantom,
  phantom_eth: Phantom,
  solflare: Solflare,
  tread: Tread,
  default: Tread,
};

export default ICONS;
